module.exports = __webpack_public_path__ + "img/exclusive@2x.9415fa0.webp";